import { Observable } from 'rxjs';

export abstract class FilterHttpService {
	abstract getChildParamDropdownValues(
		params: IGetChildParamDropdownValuesParams
	): Observable<Array<IFilterParamDropdownValues>>;
}

export interface IGetChildParamDropdownValuesParams {
	parentId: number;
	parentValue: any;
	parentName: string;
	childSmartId?: number;
	parentType?: number | string;
	contextId?: number;
	valueProperty?: string;
	titleProperty?: string;
}

export interface IFilterParamDropdownValues {
	value: any;
	title: string;
}
